import { ArrowForward } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Stack,
} from "@mui/material";
import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Home_Page from "../assets/images/Home_Page.jpg";
import Explore from "../assets/images/Explore.jpg";
import Dashboard_Home_Page from "../assets/images/Dashboard_Home_Page.jpg";
import Sign_Home_Page from "../assets/images/Sign_Home_Page.jpg";
import Gym_Home_Page from "../assets/images/Gym_Home_Page.jpg";
import Home_Gym_Page from "../assets/images/Home_Gym_Page.jpg";
import Yoga_Home_Page from "../assets/images/Yoga_Home_Page.jpg";
import { Update } from "../App";

const Home = () => {
  const { setDisplayAppBar,mode } = useContext(Update);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.pathname === "/") {
      setDisplayAppBar("block");
    }
  }, [location.pathname]);

  return (
    <>
      <Card
        sx={{
          boxShadow: "0px 0px 0px 0px white",
          mt: { sm: "10%", md: "13%", lg: "10%", xl: "7%" },
        }}
      >
        <Box sx={{ m: "auto", width: { sm: "657px", lg: "1064px" } }}>
          <CardContent
            sx={{ fontFamily: "sans-serif",pb: "2px",textAlign: "center",textAlignLast: "center",fontSize: { xs: "20px", sm: "30px", lg: "40px", xl: "50px" } }}
          >
            If you are healthy, you are wealthy
          </CardContent>
          <CardContent
            sx={{textAlign: "center",pt: "0px",fontSize: { xs: "10px", sm: "15px", xl: "18px" }}}>
            Transform your body, transform your life - with our fitness app.
          </CardContent>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Button variant="contained" color={mode==="light"?("error" ): ('primary')}
              sx={{mt: "2%",mb: "5%",p: "10px 30px",fontSize: { xs: "10px", sm: "13px", lg: "16px", xl: "18px" },borderRadius: "30px",}}
              onClick={() => {navigate("/explore");}}>
              Explore
            </Button>
          </Box>
        </Box>
      </Card>
      <Card sx={{ boxShadow: "0px 0px 0px 0px white", width: "99.7%" }}>
        <Card sx={{ height: { md: "1230px", lg: "1800px" } }}>
          <CardMedia component="img" src={Home_Page} />
        </Card>
      </Card>
        <CardContent
          sx={{mt: "8%",mb:"1%",textAlignLast: "center",display: "flex",justifyContent: "center",textAlign: "center",fontSize: { xs: "20px", sm: "30px", lg: "40px", xl: "50px" },}}>
          To enhance the efficacy of your workout.
        </CardContent>
      <Grid
        sx={{ justifyContent: "center" }}
        container rowSpacing={3} columnSpacing={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }} columns={{ xs: 13, sm: 13, md: 13, lg: 13, xl: 13 }}>
        <Grid item xs={6} sm={6} md={4} lg={4}>
          <Card>
            <CardMedia component="img" src={Explore} />
            <CardContent
              sx={{
                fontWeight: "bold",
                fontSize: {xs: ".7rem",sm: "1rem",md: "1.0rem",lg: "1.2rem",xl: "1.6rem",},}}>
              Explore
            </CardContent>
            <CardContent
              sx={{
                fontSize: {xs: ".7rem",sm: "1rem",md: "1.0rem",lg: "1.2rem",xl: "1.6rem"}}}>
              Welcome to our "Explore" page! Discover 1300+ exercises with
              animations, organized by body part and equipment. Elevate your
              fitness routine .
            </CardContent>
            <Button
              variant="text"
              color="warning"
              onClick={() => {
                navigate("/explore");
              }}
              sx={{
                fontSize: {
                  xs: ".4rem",
                  sm: ".8rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Explore <ArrowForward sx={{ fontSize: "small" }} />
            </Button>
          </Card>
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={4}>
          <Card>
            <CardMedia component="img" src={Dashboard_Home_Page} />
            <CardContent
              sx={{
                fontWeight: "bold",
                fontSize: {
                  xs: ".7rem",
                  sm: "1rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              DashBoard
            </CardContent>
            <CardContent
              sx={{
                fontSize: {
                  xs: ".7rem",
                  sm: "1rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Track your progress with our dashboard! Graphs for yoga, gym, and
              home workouts help you stay motivated. Achieve your fitness goals
              with ease!
            </CardContent>
            <Button
              variant="text"
              color="warning"
              onClick={() => {
                navigate("dashboard");
              }}
              sx={{
                fontSize: {
                  xs: ".4rem",
                  sm: ".8rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Explore DashBoard <ArrowForward sx={{ fontSize: "small" }} />
            </Button>
          </Card>
        </Grid>
        <Grid item xs={6} sm={6} md={4} lg={4}>
          <Card>
            <CardMedia component="img" src={Sign_Home_Page} />
            <CardContent
              sx={{
                fontWeight: "bold",
                fontSize: {
                  xs: ".7rem",
                  sm: "1rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              SignUp
            </CardContent>
            <CardContent
              sx={{
                fontSize: {
                  xs: ".7rem",
                  sm: "1rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Sign up. Log in. Get fit! Join our community for personalized
              workouts, progress tracking, and connections with fellow fitness
              enthusiasts.
            </CardContent>
            <Button
              variant="text"
              color="warning"
              onClick={() => {
                navigate("/login");
              }}
              sx={{
                fontSize: {
                  xs: ".4rem",
                  sm: ".8rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              SignUp/SignIn <ArrowForward sx={{ fontSize: "small" }} />
            </Button>
          </Card>
        </Grid>
      </Grid>

      <Stack rowGap={5} sx={{ mt: "7%", mb: "7%" }}>
        <Grid
          container
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          columnSpacing={1}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
        >
          <Grid item xs={10} sm={10} md={5} lg={5} xl={5}>
            <CardMedia
              component="img"
              src={Gym_Home_Page}
              sx={{ borderRadius: "10px" }}
            />
          </Grid>

          <Grid item xs={10} sm={10} md={5} lg={5} xl={5}>
            <CardContent
              sx={{
                fontWeight: "bold",
                fontSize: {
                  xs: ".7rem",
                  sm: "1rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Gym
            </CardContent>
            <CardContent
              sx={{
                fontSize: {
                  xs: ".7rem",
                  sm: "1rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Welcome to our Gym section! Personalized exercises for beginners,
              intermediates, and advanced levels. Customizable workouts,
              energizing music playlists connected to Spotify, and a performance
              dashboard to track your progress. Join us and elevate your fitness
              game!
            </CardContent>
            <Button
              variant="text"
              color="error"
              onClick={() => {
                navigate("/gym");
              }}
              sx={{
                fontSize: {
                  xs: ".4rem",
                  sm: ".8rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Explore Gym <ArrowForward sx={{ fontSize: "small" }} />
            </Button>
          </Grid>
        </Grid>

        <Grid
          container
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          columnSpacing={1}
          columns={{ md: 12, lg: 12, xl: 12 }}
        >
          <Grid
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "block",
                lg: "block",
                xl: "block",
              },
            }}
            item
            md={5}
            lg={5}
            xl={5}
          >
            <CardContent
              sx={{
                fontWeight: "bold",
                fontSize: {
                  xs: ".4rem",
                  sm: ".8rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Home Workout
            </CardContent>
            <CardContent
              sx={{
                fontSize: {
                  xs: ".7rem",
                  sm: "1rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Discover our home workout feature! Achieve fitness goals at home
              with diverse exercise routines. Personalized programs for all
              levels. Transform your living room into a dynamic gym. Join today
              for a healthier, energized lifestyle at a click!
            </CardContent>
            <Button
              variant="text"
              color="primary"
              onClick={() => {
                navigate("/homeworkout");
              }}
              sx={{
                fontSize: {
                  xs: ".4rem",
                  sm: ".8rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Explore Home Workout <ArrowForward sx={{ fontSize: "small" }} />
            </Button>
          </Grid>
          <Grid
            sx={{
              display: {
                xs: "none",
                sm: "none",
                md: "block",
                lg: "block",
                xl: "block",
              },
            }}
            item
            md={5}
            lg={5}
            xl={5}
          >
            <CardMedia
              component="img"
              src={Home_Gym_Page}
              sx={{ borderRadius: "10px" }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          columnSpacing={1}
          columns={{ xs: 12, sm: 12 }}
        >
          <Grid
            item
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
                lg: "none",
                xl: "none",
              },
            }}
            xs={10}
            sm={10}
          >
            <CardMedia
              component="img"
              sx={{ objectFit: "cover" }}
              src={Home_Gym_Page}
            />
          </Grid>
          <Grid
            item
            sx={{
              display: {
                xs: "block",
                sm: "block",
                md: "none",
                lg: "none",
                xl: "none",
              },
            }}
            xs={10}
            sm={10}
          >
            <CardContent
              sx={{
                fontWeight: "bold",
                fontSize: {
                  xs: ".7rem",
                  sm: "1rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Gym
            </CardContent>
            <CardContent
              sx={{
                fontSize: {
                  xs: ".7rem",
                  sm: "1rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Discover our home workout feature! Achieve fitness goals at home
              with diverse exercise routines. Personalized programs for all
              levels. Transform your living room into a dynamic gym. Join today
              for a healthier, energized lifestyle at a click!
            </CardContent>
            <Button
              variant="text"
              color="primary"
              onClick={() => {
                navigate("/homeworkout");
              }}
              sx={{
                fontSize: {
                  xs: ".4rem",
                  sm: ".8rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Explore Home Workout <ArrowForward sx={{ fontSize: "small" }} />
            </Button>
          </Grid>
        </Grid>

        <Grid
          container
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          columnSpacing={1}
          columns={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
        >
          <Grid item xs={10} sm={10} md={5} lg={5} xl={5}>
            <CardMedia
              component="img"
              src={Yoga_Home_Page}
              sx={{ borderRadius: "10px" }}
            />
          </Grid>
          <Grid item xs={10} sm={10} md={5} lg={5} xl={5}>
            <CardContent
              sx={{
                fontWeight: "bold",
                fontSize: {
                  xs: ".7rem",
                  sm: "1rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Yoga
            </CardContent>
            <CardContent
              sx={{
                fontSize: {
                  xs: ".7rem",
                  sm: "1rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Explore our yoga feature! Elevate well-being with diverse
              practices. Tailored routines for all levels. Find tranquility at
              home. Join today for a balanced, harmonious lifestyle. Begin your
              yoga journey with ease.
            </CardContent>
            <Button
              variant="text"
              color="warning"
              onClick={() => {
                navigate("/yoga");
              }}
              sx={{
                fontSize: {
                  xs: ".4rem",
                  sm: ".8rem",
                  md: "1.0rem",
                  lg: "1.2rem",
                  xl: "1.6rem",
                },
              }}
            >
              Explore Yoga{" "}
              <ArrowForward
                sx={{
                  fontSize: {
                    xs: "small",
                    sm: "small",
                    md: "medium",
                    lg: "large",
                    xl: "large",
                  },
                }}
              />
            </Button>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default Home;
